// Implements the Home page and current process status display.
import React from 'react';
import { Button } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import StageProgress from '../stageprogress/StageProgress';
import userStore from '../../store/userStore';
import { Config } from '../../config';

export default class home extends React.Component {

    constructor() {
        super();
        this.stages = [];
        this.state = {
            stage: userStore.user.stage
        };
    }

    componentWillMount() {
        // Array of stage objects to be passed into the StageProgress component
        this.stages = new StageManager(this.props.history).getAllStages();
        userStore.on('User-Changes', this.setUserStage);
        this.setState({ stage: userStore.user.stage });
    }
    componentWillUnmount() {
        userStore.removeListener('User-Changes', this.setUserStage);
    }
    setUserStage = () => this.setState({ stage: userStore.user.stage });
    // Stub handler for demo purposes - increments/decrements the stage.
    stepProgress(type) {
        let newStage = this.state.stage;
        if (type === 'inc' && this.state.stage < this.stages.length - 1) {
            newStage++;
        }
        else if (type === 'dec' && this.state.stage !== 0) {
            newStage--;
        }
        userStore.setUserStage(newStage);
    }

    render() {
        // if (this.state.stage === undefined) {
        //     logout();
        //     this.props.history.push("/");
        // }
        return (<div style={{
            textAlign: 'left', width: "80%", margin: 'auto',
            top: "12vh", position: "relative"
        }}>
            <p>Welcome to the Doherty Site Creator system.  Below is the current stage of the process:-</p>
            <StageProgress stage={this.state.stage} stagesArray={this.stages} history={this.props.history}></StageProgress>
            {Config.env === "dev" ? <span> <Button onClick={() => { this.stepProgress('inc'); }}> + </Button>
                <Button onClick={() => { this.stepProgress('dec'); }}> - </Button> </span> : null}
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Home.js